const layout = {
  navDrawerWidth: 20, // rem
  navBarHeight: 4,
  ContentBoxElevation: 2,
};

export default layout;
